<fieldset>
 <legend>
  TypeFournitures
 </legend>
 <app-form-input 
[parentForm]="parentForm" 
[value]="marcheFournitures.locationVente" 
 
[label]="'locationVente'"
[type]="'text'"
[rule]="''"
[name]="getUid()+'_SepAtt_locationVente'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm" 
[value]="marcheFournitures.achat" 
 
[label]="'achat'"
[type]="'text'"
[rule]="''"
[name]="getUid()+'_SepAtt_achat'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm" 
[value]="marcheFournitures.location" 
 
[label]="'location'"
[type]="'text'"
[rule]="''"
[name]="getUid()+'_SepAtt_location'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm" 
[value]="marcheFournitures.creditBail" 
 
[label]="'creditBail'"
[type]="'text'"
[rule]="''"
[name]="getUid()+'_SepAtt_creditBail'">
</app-form-input>
</fieldset>